module.exports = __webpack_public_path__ + "static/media/lampada.4ce288de.png";